import React, { useEffect, useState } from 'react';
import CookieConsent from 'react-cookie-consent';
import './index.scss';

const CookieConsentComponent: React.FC = () => {
  // const [isMobile, setIsMobile] = useState(window.innerWidth < 820);

  //   useEffect(() => {
  //     const handleResize = () => {
  //       setIsMobile(window.innerWidth < 820);
  //     };
  
  //     window.addEventListener("resize", handleResize);
  //     return () => window.removeEventListener("resize", handleResize);
  //   }, []);

  return (
    <CookieConsent
      location="bottom"
      buttonText="I AGREE"
      cookieName="walkzero"
      containerClasses="cookie-container"
      buttonWrapperClasses="cookie-button-wrapper"
      buttonClasses="btn-cookie"
    >
      <div className='cookie-notice-outer'>
        <div className="cookie-notice">
          Walkzero uses cookies to ensure you get the best experience on our website. If you continue browsing it we will assume that you are happy to have all cookies placed by the Walkzero website. <span><a href="/cookie-policy" className='Cookie-hover'>Cookie Policy</a></span>
        </div>
      </div>
    </CookieConsent>
  );
};

export default CookieConsentComponent;